<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import required from "vuelidate/lib/validators/required";
import Employee from "@/components/modals/employee-hris";
import PropertyTransfer from "@/router/views/office/office-widgets/property-transfer";

export default {
  page: {
    title: "Properties",
  },
  components: {
    Layout,
    PageHeader,
    PropertyTransfer,
    Employee,
  },
  data() {
    return {
      title: "Properties",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Properties",
          active: true,
        },
      ],
      tableData: [],
      transferData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      toggleAll: false,
      campusId: this.$store.state.data.selectedCampus.id,
      form: {
        propertyAssignmentId: [],
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: "",
      },
      tableBusy: false,
      employeeId: "",
      employeeName: "",
      employeeTransfer: "",
      propertyTransferEmployeeModal: null,
      getEmployeeType: "",
      propertyTransfer: false,
      tabIndex: 0,
    };
  },
  validations: {
    form: {
      type: { required },
      reason: { required },
      transferToEmployeeId: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(this.filter.toUpperCase()))
            return item.name.toUpperCase().includes(this.filter.toUpperCase());
          else if (item.propertyNumber)
            if (
              item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            else if (item.serialNumber)
              if (
                item.serialNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return item.serialNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
    compareCost() {
      if (
        parseFloat(this.getExactAmt(this.minCost)) >
          parseFloat(this.getExactAmt(this.maxCost)) ||
        (this.getExactAmt(this.minCost) != "" &&
          this.getExactAmt(this.maxCost) == "")
      )
        return 1;
      else return 0;
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    // change campus
    changeCampus(data) {
      this.campusId = data.id;
    },
    // get
    getData() {
      if (this.employeeId != "") {
        if (this.tabIndex == 0) {
          this.getEmployeeAll();
        } else if (this.tabIndex == 1) {
          this.getEmployeeTransfer();
        }
      }
    },
    async getEmployeeAll() {
      if (this.employeeId != "") {
        this.tableBusy = true;
        await this.getTransferCheck();
        var employeeIdNumber = this.employeeId.trim();
        await this.$store
          .dispatch(
            "property/GetPropertybyAccountableOfficer",
            employeeIdNumber
          )
          .then((res) => {
            res.data.properties.forEach((item) => {
              item.toggleSelected = false;
              item.pendingTransfer = false;
              if (this.checkTransfer(item.id)) {
                item.pendingTransfer = true;
              }
            });
            this.tableData = res.data.properties;
            this.toggleAll = false;
            this.filter = "";
            window.scrollTo(0, 0);
            this.tableBusy = false;
          })
          .catch(() => {
            this.tableBusy = false;
            this.showToast(
              "Something went wrong - Getting property list!",
              "error"
            );
          });
      }
    },
    getEmployeeTransfer() {
      this.$refs.propertytransfer.getData(this.employeeId);
    },
    async getTransferCheck() {
      await this.$store
        .dispatch(
          "propertytransfer/GetPropertyTransferDraftByEmployee",
          this.employeeId
        )
        .then((res) => {
          this.transferData = res.data;
        });
      await this.$store
        .dispatch(
          "propertytransfer/GetPropertyTransferPostedByEmployee",
          this.employeeId
        )
        .then((res) => {
          this.transferData = this.transferData.concat(res.data);
        });
    },
    checkTransfer(id) {
      if (this.transferData.length > 0) {
        var data = this.transferData.filter((item) => {
          return item.propertyAssignment.propertyId == id;
        });
        if (data.length > 0) {
          return true;
        } else return false;
      } else return false;
    },
    viewInspect() {
      if (this.$refs.carousel) {
        this.propertyTransfer = true;
        this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      }
    },
    returnToTable() {
      if (this.$refs.carousel) {
        this.propertyTransfer = false;
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      }
    },
    onTransferItem() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You are about to transfer the selected property.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, transfer it!",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            var data = [];
            this.form.propertyAssignmentId.forEach((item) => {
              data.push({
                propertyAssignmentId: item,
                type: this.form.type,
                reason: this.form.reason,
                transferToEmployeeId: this.form.transferToEmployeeId,
                remarks: this.form.remarks,
              });
            });
            this.$store
              .dispatch("propertytransfer/CreatePropertyTransfer", data)
              .then(() => {
                this.form.propertyAssignmentId.forEach((x) => {
                  var index = this.tableData.findIndex(
                    (y) => x == y.currentAssignment.id
                  );
                  this.tableData[index].toggleSelected = true;
                });
                this.getEmployeeAll();
                this.showToast("Successfully transfered", "success");
                this.$bvModal.hide("assignmenthistory-modal-transfer");
              })
              .catch((err) => {
                this.showToast("Cannot be transfered!", "error");
              });
          }
        });
      }
      this.submitted = false;
    },
    transferItem(props) {
      this.onReset();
      this.form.propertyAssignmentId.push(props.currentAssignment.id);
      this.form.type = "Reassignment";
      this.modalTitle = "Transfer Item";
      this.$bvModal.show("assignmenthistory-modal-transfer");
    },
    transferMultipleItem() {
      this.onReset();
      this.filtered.forEach((item) => {
        if (item.toggleSelected == true)
          this.form.propertyAssignmentId.push(item.currentAssignment.id);
      });
      this.form.type = "Reassignment";
      this.modalTitle = "Transfer Item";
      this.$bvModal.show("assignmenthistory-modal-transfer");
    },
    onReset() {
      this.form = {
        propertyAssignmentId: [],
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: "",
      };
      this.submitted = false;
      this.employeeTransfer = "";
    },
    getEmployee(type) {
      if (type == "get") this.$refs.employee.getDuEmployee();
      else if (type == "transfer") this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    async dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      if (this.getEmployeeType == "get") {
        this.employeeId = data.idNo;
        this.employeeName = firstname.concat(" ", lastname);
        await this.getData();
      } else if (this.getEmployeeType == "transfer") {
        this.form.transferToEmployeeId = data.idNo;
        this.employeeTransfer = firstname.concat(" ", lastname);
      } else {
        this.propertyTransferEmployeeModal = data;
      }
    },
    selectAll() {
      this.filtered.forEach((item) => {
        item.toggleSelected = false;
      });
      if (this.toggleAll === true) {
        this.filtered.sort((a, b) => a.id - b.id);
        var total = this.currentPage * this.perPage;
        var currentData = this.filtered.slice(total - this.perPage, total);
        if (this.currentPage > 1 && currentData.length == 0) {
          total = (this.currentPage - 1) * this.perPage;
          currentData = this.filtered.slice(total - this.perPage, total);
        }
        currentData.forEach((item) => {
          if (!item.pendingTransfer) item.toggleSelected = true;
        });
      }
    },
    checkToggle() {
      this.filtered.sort((a, b) => a.id - b.id);
      var total = this.currentPage * this.perPage;
      var currentData = this.filtered.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = this.filtered.slice(total - this.perPage, total);
      }
      var count = 0;
      var availableData = 0;
      currentData.forEach((item) => {
        if (item.toggleSelected && !item.pendingTransfer) count++;
        if (!item.pendingTransfer) availableData++;
      });
      if (count === availableData) {
        this.toggleAll = true;
      } else {
        this.toggleAll = false;
      }
    },
    resetToggle() {
      this.toggleAll = false;
      this.filtered.forEach((item) => {
        item.toggleSelected = false;
      });
    },
    checkSelectedItems() {
      var count = 0;
      this.filtered.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count > 0) return true;
      else return false;
    },
  },
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Transfer Property -->
    <b-modal
      id="assignmenthistory-modal-transfer"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onTransferItem"
        class="needs-validation"
        ref="fcForm"
      >
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('transfer')" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Employee..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (form.transferToEmployeeId == null ||
                    form.transferToEmployeeId == ''),
              }"
              v-model="employeeTransfer"
            />
          </b-input-group>
          <div
            v-if="
              submitted &&
              (form.transferToEmployeeId == null ||
                form.transferToEmployeeId == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select
            class="form-select"
            :class="{
              'is-invalid': submitted && (form.type == null || form.type == ''),
            }"
            v-model="form.type"
          >
            <b-form-select-option value="" disabled
              >Select Type...</b-form-select-option
            >
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation"
              >Donation</b-form-select-option
            >
            <b-form-select-option value="Reassignment"
              >Reassignment</b-form-select-option
            >
            <b-form-select-option value="Relocate"
              >Relocate</b-form-select-option
            >
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div
            v-if="submitted && (form.type == null || form.type == '')"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="reason">Reason</label>
          <textarea
            id="reason"
            rows="2"
            v-model="form.reason"
            placeholder="Enter Reason..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted && (form.reason == null || form.reason == ''),
            }"
            autocomplete="off"
          ></textarea>
          <div
            v-if="submitted && (form.reason == null || form.reason == '')"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">
            Transfer Property
          </button>
        </div>
      </form>
    </b-modal>
    <div>
      <!-- Main -->
      <div class="row">
        <!-- Select Employee -->
        <div class="col-md-3">
          <div class="card">
            <div class="card-body pt-3 pb-4 ps-4 pe-4">
              <div class="mb-2">Select Employee</div>
              <b-input-group>
                <template #append>
                  <b-button @click="getEmployee('get')" variant="outline-info"
                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                  ></b-button>
                </template>
                <input
                  autocomplete="off"
                  type="text"
                  placeholder="Select Employee..."
                  class="form-control rounded border-light"
                  v-model="employeeName"
                  disabled
                />
              </b-input-group>
            </div>
          </div>
        </div>
        <!-- Properties -->
        <div class="col-md-9">
          <b-tabs
            content-class="text-muted"
            v-model="tabIndex"
            nav-class="nav-tabs-custom"
          >
            <!-- All -->
            <b-tab
              @click="
                getEmployeeAll();
                perPage = 10;
                currentPage = 1;
              "
            >
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="mdi mdi-account-details-outline"></i>
                </span>
                <span class="d-none d-sm-inline-block">All</span>
              </template>
              <div v-if="tabIndex == 0" class="pt-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-2 pt-2"
                >
                  <div class="d-flex">
                    <h5 class="mb-0 pt-2 pe-3">List of Properties</h5>
                    <button
                      v-if="checkSelectedItems()"
                      type="button"
                      class="btn btn-sm btn-success d-flex align-items-center ms-1"
                      @click="transferMultipleItem()"
                    >
                      <i class="mdi mdi-account-convert-outline fs-6 me-1"></i
                      >Transfer Properties
                    </button>
                  </div>
                  <div class="d-flex">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          @input="
                            currentPage = 1;
                            resetToggle();
                          "
                          placeholder="Search Property..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
                <b-card v-if="tableBusy">
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-25px h-25px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <h5 class="mb-0">Loading...</h5>
                  </div>
                </b-card>
                <b-card class="text-center" v-else-if="filtered.length == 0">
                  <div v-if="employeeId == ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>Select an
                    employee
                  </div>
                  <div v-else-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    items matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No
                    properties assigned
                  </div>
                </b-card>
                <div v-else class="text-muted">
                  <b-card
                    no-body
                    class="m-0 mb-3"
                    style="min-width: fit-content"
                  >
                    <b-card-header>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div style="min-width: 200px">
                          <div class="d-flex align-items-center">
                            <div
                              style="width: 25px"
                              class="form-check form-checkbox-outline form-check-success me-2"
                            >
                              <input
                                type="checkbox"
                                id="checkbox-location"
                                checked="checked"
                                class="form-check-input"
                                @change="selectAll()"
                                v-model="toggleAll"
                              />
                            </div>
                            <div>
                              <h6
                                class="text-muted m-0"
                                style="min-width: 200px"
                              >
                                Property
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <h6 class="text-muted m-0" style="min-width: 200px">
                            PO Number
                          </h6>
                          <h6 class="text-muted m-0" style="min-width: 200px">
                            Current Value
                          </h6>
                          <h6
                            class="text-muted text-center m-0"
                            style="min-width: 70px"
                          >
                            Action
                          </h6>
                        </div>
                      </div>
                    </b-card-header>
                  </b-card>
                  <div
                    role="tablist"
                    v-for="(x, index) in filtered"
                    :key="x.id"
                  >
                    <b-card
                      no-body
                      class="m-0 mb-3"
                      style="min-width: fit-content"
                      :style="`z-index: ${filtered.length - index + 10}`"
                    >
                      <b-card-header>
                        <div class="d-flex justify-content-between">
                          <div style="min-width: 200px">
                            <div class="d-flex align-items-center">
                              <div
                                style="width: 25px"
                                class="form-check form-checkbox-outline form-check-success me-2"
                              >
                                <input
                                  v-if="!x.pendingTransfer"
                                  type="checkbox"
                                  :id="`apiID-${x.id}`"
                                  class="form-check-input"
                                  @change="checkToggle()"
                                  v-model="x.toggleSelected"
                                />
                                <input
                                  v-else
                                  type="checkbox"
                                  :id="`apiID-${x.id}`"
                                  class="form-check-input"
                                  disabled
                                />
                              </div>
                              <div>
                                <h6 class="m-0">
                                  {{ x.name }}
                                </h6>
                                <small>Property# {{ x.propertyNumber }}</small>
                              </div>
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div style="min-width: 200px">
                              {{ x.poNumber }}
                            </div>
                            <div class="text-warning" style="min-width: 200px">
                              {{ formatCurrency(x.currentValue) }}
                            </div>
                            <div
                              class="d-flex justify-content-center"
                              style="min-width: 70px"
                            >
                              <a
                                title="Transfer"
                                v-if="!x.pendingTransfer"
                                href="javascript:void(0);"
                                class="text-success"
                                @click="transferItem(x)"
                                ><i
                                  class="mdi mdi-account-convert-outline fs-2"
                                ></i
                              ></a>
                              <a v-else class="text-secondary"
                                ><i
                                  class="mdi mdi-account-convert-outline fs-2"
                                ></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                  </div>
                </div>
                <div class="row">
                  <div v-if="rows > 0" class="col">
                    Showing {{ (currentPage - 1) * perPage + 1 }} -
                    {{
                      rows > (currentPage - 1) * perPage + perPage
                        ? (currentPage - 1) * perPage + perPage
                        : rows
                    }}
                    of {{ rows }}
                  </div>
                  <div class="col">
                    <div
                      @click="resetToggle()"
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul
                        class="pagination pagination-rounded mb-0"
                        style="z-index: -1"
                      >
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </b-tab>
            <!-- Transfer -->
            <b-tab
              @click="
                getEmployeeTransfer();
                perPage = 10;
                currentPage = 1;
              "
            >
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="mdi mdi-account-switch"></i>
                </span>
                <span class="d-none d-sm-inline-block">Transfer</span>
              </template>
              <div v-if="tabIndex == 1" class="pt-2">
                <PropertyTransfer
                  :employeeData="propertyTransferEmployeeModal"
                  :ref="`propertytransfer`"
                  @getEmployee="getEmployee($event)"
                ></PropertyTransfer>
              </div>
              <br />
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    </div>
  </Layout>
</template>
